import Papa from 'papaparse';

const CSV_UNPARSE_OPTIONS = {
    delimiter: ',',
    newline: '\n',
    quotes: false,
};

/** Serialize invoice export rows with Papa Parse so commas, quotes, and newlines stay in one cell. */
export function rowsToCsv(rows) {
    return Papa.unparse(rows ?? [], CSV_UNPARSE_OPTIONS);
}
